<template>
  <div></div>
</template>

<script>
import { loginByWechat } from '../../api/userLogin'

export default {
  name: 'WxLoginHandler',
  created () {
    const code = this.$route.query.code
    const state = this.$route.query.state
    let sign = null
    let payload = null
    if (state !== '') {
      const signSegs = this.$route.query.state.split('|')
      sign = {
        appId: signSegs[0],
        redirectUri: signSegs[1],
        digest: signSegs[2]
      }
      payload = signSegs[3]
    }
    loginByWechat({
      code, state, sign
    })
      .then(data => {
        // 未激活的用户，跳转至用户设置页面
        if (data.userStatus === 0) {
          // 携带签名
          if (sign != null) {
            this.$router.push(`/usr/settings?appid=${sign.appId}&redirect_uri=${sign.redirectUri}&digest=${sign.digest}`)
            return
          }
          // 未携带签名
          this.$router.push('/usr/settings')
          return
        }
        // 已激活的用户
        // - 携带程序授权令牌，则直接跳转至程序
        if (data.token != null) {
          window.location.href = `${data.redirectUri}?access_token=${data.token.token}&timestamp=${data.token.timestamp}&digest=${data.token.digest}&payload=${encodeURIComponent(payload)}`
          return
        }
        // - 携带重定向地址，则跳转至指定地址
        if (data.redirectUri != null) {
          window.location.href = `${data.redirectUri}`
          return
        }
        // - 跳转至用户中心
        window.location.href = '/usr/information'
      })
      .catch(e => {
        // 存在多账户
        if (e.code === 'USER_UNEXACT') {
          // 携带签名，确认账户后跳转至程序
          if (sign != null) {
            this.$router.push(`/usr/bind/select-account?appid=${sign.appId}&redirect_uri=${sign.redirectUri}&digest=${sign.digest}&payload=${encodeURIComponent(payload)}`)
            return
          }
          // 未携带签名，确认账户后跳转至用户中心
          this.$router.push('/usr/bind/select-account?redirect_uri=/usr/information')
          return
        }
        this.$router.push(`/500?code=${e.code}&error=${e.message}`)
      })
  }
}
</script>
